<script setup lang="ts">
import useLocale from '../composables/use-locale';

const props = withDefaults(
  defineProps<{
    top?: string;
    left?: string;
    goBack?: () => void;
  }>(),
  {
    top: '80px',
    left: '16px',
  },
);

const emits = defineEmits<{ (e: 'goBack'): void }>();

const { t } = useLocale();

const handleBack = () => {
  if (props.goBack) {
    props.goBack();
  } else {
    emits('goBack');
  }
};
</script>

<template>
  <v-btn
    icon="fa:fas fa-chevron-left"
    variant="text"
    size="small"
    :style="{ position: 'fixed', top: props.top, left: props.left, zIndex: 11 }"
    @click="handleBack"
    :aria-label="t('label_go_back')"
  />
</template>

<style scoped lang="scss"></style>
